const amount = (value) => {
  if (value == null || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
};

export const calculateBookDiscount = (price, originalPrice) => {
  const sale = amount(price);
  const mrp = amount(originalPrice);
  if (sale == null || mrp == null) return '';
  return mrp > sale ? Math.round(((mrp - sale) / mrp) * 100) : 0;
};

export const updateBookPricing = (form, currency, field, value, basis = 'price') => {
  const [priceField, originalField, discountField] = currency === 'USD'
    ? ['usdPrice', 'usdOriginalPrice', 'usdDiscount']
    : ['price', 'originalPrice', 'discount'];
  const next = { ...form, [field]: value };
  if (field === discountField) {
    const percentage = amount(value);
    const mrp = amount(form[originalField]);
    if (percentage != null && percentage <= 100 && mrp != null) {
      next[priceField] = (mrp * (1 - percentage / 100)).toFixed(2);
      next[discountField] = calculateBookDiscount(next[priceField], mrp);
    }
  } else {
    // Keep an explicitly entered percentage while its MRP is being typed.
    const percentage = amount(form[discountField]);
    const mrp = amount(next[originalField]);
    if (field === originalField && basis === 'discount' && mrp != null
      && percentage != null && percentage <= 100) {
      next[priceField] = (mrp * (1 - percentage / 100)).toFixed(2);
    }
    next[discountField] = calculateBookDiscount(next[priceField], next[originalField]);
  }
  return next;
};
